import axios from "axios";
import React, { useState, useEffect } from "react";
import { Button } from "reactstrap"; 
import {
  checkPermission,
  check_Bussiness_Permission,
} from "../../../../Helper";
import moment from "moment";
import ExportToExcel from "../../SExport/ExportToExcle";
import ReportsCriteria from "../../ShortCutComponents/ReportsCriteria";
import { TableSumCustom } from "../../ShortFunction/TableSumCustom";
import { baseurl } from "../../../../baseurl";
import { generateCriteriaString } from "../../ShortFunction/shortFunctions";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import swal from "sweetalert";

let companyId = localStorage.getItem("companyId");
let username  = localStorage.getItem("username");
let token     = localStorage.getItem("token");

function amountFormatter(cell) {
  if (cell === null || cell === undefined || cell === "") return "-";
  const num = typeof cell === "string" ? parseFloat(cell) : cell;
  if (!num && num !== 0) return "-";
  return num.toLocaleString("en-US", {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  });
}

function dateFormatter(cell) {
  if (!cell) return "-";

  const m = moment(cell);

  if (!m.isValid()) return "-";

  // if (
  //   m.hour() === 0 &&
  //   m.minute() === 0
  // ) {
  //   return m.format("DD-MMM-YYYY");
  // }

  return m.format("DD-MMM-YYYY HH:mm");
}

function typeFormatter(cell) {
  if (!cell) return "-";
  const color =
    cell === "Delivery"
      ? { background: "#d4edda", color: "#155724" }
      : { background: "#cce5ff", color: "#004085" };
  return (
    <span
      style={{
        ...color,
        padding: "2px 8px",
        borderRadius: "12px",
        fontSize: "11px",
        fontWeight: "500",
      }}
    >
      {cell}
    </span>
  );
}

const tabStyle = (active, color) => ({
  padding: "8px 20px",
  marginRight: "4px",
  borderRadius: "6px 6px 0 0",
  border: "1px solid #c8ced3",
  borderBottom: active ? "2px solid " + color : "1px solid #c8ced3",
  background: active ? "#fff" : "#f0f3f5",
  color: active ? color : "#73818f",
  fontWeight: active ? "600" : "400",
  cursor: "pointer",
  fontSize: "13px",
  outline: "none",
  transition: "all 0.15s",
});

export default function OrderSummaryReport(props) {

  const [data, setData] = useState({
    criteriaString: "All",
    fromDate: "",
  });
  const [criteria, setCriteria]   = useState(null); 
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("1"); // "1"=Created "2"=Delivered "3"=Settled "4"=Pending

  const [createdData,   setCreatedData]   = useState([]);
  const [deliveredData, setDeliveredData] = useState([]);
  const [settledData,   setSettledData]   = useState([]); // Changed from paidData to settledData for clarity
  const [pendingData,   setPendingData]   = useState([]); // Added for pending settlements

  const [createdTotals,   setCreatedTotals]   = useState({});
  const [deliveredTotals, setDeliveredTotals] = useState({});
  const [settledTotals,   setSettledTotals]   = useState({}); // Changed from paidTotals
  const [pendingTotals,   setPendingTotals]   = useState({}); // Added for pending
 const createdColLabels = [
    { align: "center", value: "Order No."          },
    { align: "left",   value: "Customer"            },
    { align: "left",   value: "Customer PH#"        },
    { align: "center", value: "Order Date"          },
    { align: "center", value: "Delivery/Pickup"     },
    { align: "center", value: "Delivery Date Time"  },
    { align: "right",  value: "Bill Amount"         },
    { align: "right",  value: "Advance"             },
    { align: "right",  value: "Remaining"           },
  ];
  const createdColKeys = [
    { align: "right",  value: "ORDER_NO"           },
    { align: "left",   value: "CUSTOMER"       },
    { align: "left",   value: "CUSTOMER_PH"         },
    { align: "center", value: "ORDER_DATE"          },
    { align: "center", value: "DELIVERY_PICKUP"     },
    { align: "center", value: "DELIVERY_DATETIME"  },
    { align: "right",  value: "BILL_AMOUNT"         },
    { align: "right",  value: "ADVANCE"             },
    { align: "right",  value: "REMAINING"           },
  ];

  // Tab 2 – Orders Delivered
  const deliveredColLabels = [
    { align: "center", value: "Order No."              },
    { align: "left",   value: "Customer"               },
    { align: "left",   value: "Customer PH#"           },
    { align: "center", value: "Delivery Date Time"     },
    { align: "left",   value: "Vehicle No./Pickuped by"},
    { align: "center", value: "Delivered On"           },
    { align: "right",  value: "Bill Amount"            },
    { align: "right",  value: "Advance"                },
    { align: "right",  value: "Amount Received"        },
    { align: "right",  value: "Remaining"              },
  ];
  const deliveredColKeys = [
    { align: "right",  value: "ORDER_NO"           },
    { align: "left",   value: "CUSTOMER"       },
    { align: "left",   value: "CUSTOMER_PH"         },
    { align: "center", value: "DELIVERY_DATETIME"  },
    { align: "left",   value: "VEHICLENO_PICKUPBY"          },
    { align: "center", value: "DELIVERED_ON"        },
    { align: "right",  value: "BILL_AMOUNT"         },
    { align: "right",  value: "ADVANCE"             },
    { align: "right",  value: "AMOUNT_RECEIVED"     },
    { align: "right",  value: "REMAINING"           },
  ];

  // Tab 4 – Pending Settlements
  const pendingColLabels = [
    { align: "center", value: "Order No."          },
    { align: "left",   value: "Customer"            },
    { align: "left",   value: "Customer PH#"        },
    { align: "center", value: "Delivery Date Time"  },
    { align: "center", value: "Delivered On"        },
    { align: "center", value: "Installments"        },
    { align: "right",  value: "Bill Amount"         },
    { align: "right",  value: "Advance"             },
    { align: "right",  value: "Amount Received"     },
    { align: "right",  value: "Remaining"           },
    { align: "left",  value: "Status"           },
  ];
  const pendingColKeys = [
    { align: "right",  value: "ORDER_NO"           },
    { align: "left",   value: "CUSTOMER"       },
    { align: "left",   value: "CUSTOMER_PH"         },
    { align: "center", value: "DELIVERY_DATETIME"  },
    { align: "center", value: "DELIVERED_ON"        },
    { align: "center", value: "INSTALLMENTS"        },
    { align: "right",  value: "BILL_AMOUNT"         },
    { align: "right",  value: "ADVANCE"             },
    { align: "right",  value: "AMOUNT_RECEIVED"     },
    { align: "right",  value: "REMAINING"           },
    { align: "left",  value: "STATUS"           },
  ];

  // Tab 3 – Orders Settled (formerly Paid)
  const settledColLabels = [
    { align: "center", value: "Order No."          },
    { align: "left",   value: "Customer"            },
    { align: "left",   value: "Customer PH#"        },
    { align: "center", value: "Delivery Date Time"  },
    { align: "center", value: "Delivered On"        },
    { align: "center", value: "Installments"        },
    { align: "right",  value: "Bill Amount"         },
    { align: "right",  value: "Advance"             },
    { align: "right",  value: "Amount Received"     },
    { align: "right",  value: "Remaining"           },
  ];
  const settledColKeys = [
    { align: "right",  value: "ORDER_NO"           },
    { align: "left",   value: "CUSTOMER"       },
    { align: "left",   value: "CUSTOMER_PH"         },
    { align: "center", value: "DELIVERY_DATETIME"  },
    { align: "center", value: "DELIVERED_ON"        },
    { align: "center", value: "INSTALLMENTS"        },
    { align: "right",  value: "BILL_AMOUNT"         },
    { align: "right",  value: "ADVANCE"             },
    { align: "right",  value: "AMOUNT_RECEIVED"     },
    { align: "right",  value: "REMAINING"           },
  ];

  // ... (keep existing Tab 1 and Tab 2 labels/keys)

  // Update sum labels
  const settledSumLabels = [
    "Bill Amount", "Advance", "Amount Received", "Remaining",
  ];
  const pendingSumLabels = [
    "Bill Amount", "Advance", "Amount Received", "Remaining",
  ];

  // ... (keep all other functions unchanged until fetchOrderSummary)

  const fetchOrderSummary = (
    fromDate, multiPosBranch, branch_id
  ) => {
    const date = fromDate ? moment(fromDate).format("YYYY-MM-DD") : null;

    setIsLoading(true);

    axios
      .post(
        `${baseurl}/repots/getOrderSummaryReport`,
        {
          companyId,
          date,
          sub_inv_id: multiPosBranch || branch_id?.id || branch_id,
          activeTab,
          username,
        },
        { headers: { authorization: token } },
      )
      .then((response) => {
        const created = response.data.data1;
        const delivered = response.data.data2;
        const settled = response.data.data3; // Changed from paid
        const pending = response.data.data4;

        setCreatedData(created);
        setDeliveredData(delivered);
        setSettledData(settled); // Changed from setPaidData
        setPendingData(pending); // Now properly set

        setCreatedTotals(
          computeTotals(created, ["BILL_AMOUNT", "ADVANCE", "REMAINING"]),
        );
        setDeliveredTotals(
          computeTotals(delivered, [
            "BILL_AMOUNT", "ADVANCE", "AMOUNT_RECEIVED", "REMAINING",
          ]),
        );
        setSettledTotals( // Changed from setPaidTotals
          computeTotals(settled, [
            "BILL_AMOUNT", "ADVANCE", "AMOUNT_RECEIVED", "REMAINING",
          ]),
        );
        setPendingTotals( // Now properly set
          computeTotals(pending, [
            "BILL_AMOUNT", "ADVANCE", "AMOUNT_RECEIVED", "REMAINING",
          ]),
        );

        setIsLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setIsLoading(false);
      });
  };

  const handleFind = (p) => {
    const {
      fromDate,
      multiPosBranchLabel, multiPosBranch, branch_id
    } = p;
console.log('p', p)
    setCriteria(p);

    const critObj = {
      fromDate,
      multiPosBranchLabel: multiPosBranchLabel || branch_id?.label,
      multiPosBranch: multiPosBranch || branch_id,
      branch_id,
    };
    const criteriaString = generateCriteriaString(critObj);
    setData({ criteriaString });

    if (!fromDate) {
      swal({
        title: "Date Required",
        text: "Please select a date to generate the report.",
        icon: "warning",
      });
      return;
    }

    fetchOrderSummary(fromDate, multiPosBranch, branch_id);
  }; 
  const handlePrint = () => {
    let printData, headers, headerKeyMap, reportName, dynamicMsg; 
    if (activeTab === "1") {
      printData    = [...createdData]; 
      const totalRow ={
            ORDER_NO: "",
            CUSTOMER: "Total",
            CUSTOMER_PH: "-",
            ORDER_DATE: "-",
            DELIVERY_PICKUP: "-",
            DELIVERY_DATETIME: "-",
            BILL_AMOUNT: createdTotals.BILL_AMOUNT,
            ADVANCE: createdTotals.ADVANCE,
            REMAINING: createdTotals.REMAINING,
        }
        printData.push(totalRow)
      headers      = createdColLabels;
      headerKeyMap = createdColKeys;
      reportName   = "Day_Summary_Report_Created";
      dynamicMsg   = "Day Summary Report – Orders Created";
    } else if (activeTab === "2") {
      printData    = [...deliveredData];
      const totalRow =  {
            ORDER_NO: "",
            CUSTOMER: "Total",
            CUSTOMER_PH: "-",
            DELIVERY_DATETIME: "-",
            VEHICLENO_PICKUPBY: "-",
            DELIVERED_ON: "-",
            BILL_AMOUNT: deliveredTotals.BILL_AMOUNT,
            ADVANCE: deliveredTotals.ADVANCE,
            AMOUNT_RECEIVED: deliveredTotals.AMOUNT_RECEIVED,
            REMAINING: deliveredTotals.REMAINING
        }
      printData.push(totalRow)
      headers      = deliveredColLabels;
      headerKeyMap = deliveredColKeys;
      reportName   = "Day_Summary_Report_Delivered";
      dynamicMsg   = "Day Summary Report – Daily Orders Delivered";
    } else if (activeTab === "3") {
      printData    = [...settledData]; // Changed from paidData
      const totalRow =   {
            ORDER_NO: "",
            CUSTOMER: "Total",
            CUSTOMER_PH: "-",
            DELIVERY_DATETIME: "-",
            DELIVERED_ON: "-",
            INSTALLMENTS: "-",
            BILL_AMOUNT: settledTotals.BILL_AMOUNT, // Changed from paidTotals
            ADVANCE: settledTotals.ADVANCE,
            AMOUNT_RECEIVED: settledTotals.AMOUNT_RECEIVED,
            REMAINING: settledTotals.REMAINING
        }
      printData.push(totalRow)
      headers      = settledColLabels; // Changed from paidColLabels
      headerKeyMap = settledColKeys; // Changed from paidColKeys
      reportName   = "Daily Settlement Report";
      dynamicMsg   = "Day Summary Report – Orders Settled";
    } else { // Tab 4 - Pending
      printData    = [...pendingData]; // Changed from settleData
      const totalRow =   {
            ORDER_NO: "",
            CUSTOMER: "Total",
            CUSTOMER_PH: "-",
            DELIVERY_DATETIME: "-",
            DELIVERED_ON: "-",
            INSTALLMENTS: "-",
            BILL_AMOUNT: pendingTotals.BILL_AMOUNT, // Changed from settleTotals
            ADVANCE: pendingTotals.ADVANCE,
            AMOUNT_RECEIVED: pendingTotals.AMOUNT_RECEIVED,
            REMAINING: pendingTotals.REMAINING
        }
      printData.push(totalRow)
      headers      = pendingColLabels;
      headerKeyMap = pendingColKeys;
      reportName   = "Day_Summary_Report_Pending";
      dynamicMsg   = "Day Summary Report – Pending Settlements";
    }

    // PrintReports' PDF matches header *labels* against row keys; ours never
    // match ("Order No." vs ORDER_NO), so it falls back to Object.values(row)
    // in SQL column order. The Pending query also returns INVOICE_ID and
    // VEHICLENO_PICKUPBY, which shifted every PDF column. Hand it rows that
    // carry exactly the tab's keys, in header order. Amounts are formatted as
    // on screen; raw they print as "1500.00" and the JS-summed totals can
    // carry float noise.
    const amountKeys = ["BILL_AMOUNT", "ADVANCE", "AMOUNT_RECEIVED", "REMAINING"];
    const pdfDataArray = printData.map((r) => {
      const row = {};
      headerKeyMap.forEach((k) => {
        row[k.value] = amountKeys.includes(k.value)
          ? amountFormatter(r[k.value])
          : r[k.value] ?? "";
      });
      return row;
    });

    props.history.push({
      pathname: "/PrintReports",
      state: {
        data:         pdfDataArray,
        pdfDataArray,
        headers,
        headerKeyMap,
        goBackUrl:    "/OrderSummaryReport",
        dynamicInvMessage: dynamicMsg,
        reportName,
        criteriaString: data.criteriaString,
      },
    });
  };

  const currentExportData = () => {
    if (activeTab === "1")
      return buildExportArr(createdData,   createdColKeys,   createdTotals,   createdColLabels);
    if (activeTab === "2")
      return buildExportArr(deliveredData, deliveredColKeys, deliveredTotals, deliveredColLabels);
    if (activeTab === "3")
      return buildExportArr(settledData, settledColKeys, settledTotals, settledColLabels); // Changed from paidData
    return buildExportArr(pendingData, pendingColKeys, pendingTotals, pendingColLabels); // Changed from settleData
  };

  const currentColKeys = () => {
    if (activeTab === "1") return createdColKeys;
    if (activeTab === "2") return deliveredColKeys;
    if (activeTab === "3") return settledColKeys; // Changed from paidColKeys
    return pendingColKeys; // Changed from settleColKeys
  };

  const currentReportName = () => {
    if (activeTab === "1") return "Day_Summary_Report_Created";
    if (activeTab === "2") return "Day_Summary_Report_Delivered";
    if (activeTab === "3") return "Day_Summary_Report_Settled";
    return "Day_Summary_Report_Pending";
  };

  // const TabBar = () => (
  //   <div style={{ display: "flex", borderBottom: "2px solid #c8ced3", marginBottom: "12px", marginTop: "52px" }}>
  //     <button
  //       style={tabStyle(activeTab === "1", "#1D9E75")}
  //       onClick={() => setActiveTab("1")}
  //     >
  //       Orders Created
  //       <span
  //         style={{
  //           marginLeft: "6px",
  //           background: activeTab === "1" ? "#1D9E75" : "#c8ced3",
  //           color: "#fff",
  //           borderRadius: "10px",
  //           padding: "1px 7px",
  //           fontSize: "11px",
  //         }}
  //       >
  //         {createdData.length}
  //       </span>
  //     </button>
  //     <button
  //       style={tabStyle(activeTab === "2", "#378ADD")}
  //       onClick={() => setActiveTab("2")}
  //     >
  //       Orders Delivered
  //       <span
  //         style={{
  //           marginLeft: "6px",
  //           background: activeTab === "2" ? "#378ADD" : "#c8ced3",
  //           color: "#fff",
  //           borderRadius: "10px",
  //           padding: "1px 7px",
  //           fontSize: "11px",
  //         }}
  //       >
  //         {deliveredData.length}
  //       </span>
  //     </button>
  //     <button
  //       style={tabStyle(activeTab === "3", "#D85A30")}
  //       onClick={() => setActiveTab("3")}
  //     >
  //       Orders Settled
  //       <span
  //         style={{
  //           marginLeft: "6px",
  //           background: activeTab === "3" ? "#D85A30" : "#c8ced3",
  //           color: "#fff",
  //           borderRadius: "10px",
  //           padding: "1px 7px",
  //           fontSize: "11px",
  //         }}
  //       >
  //         {settledData.length} {/* Changed from paidData */}
  //       </span>
  //     </button>
  //     <button
  //       style={tabStyle(activeTab === "4", "#D85A30")}
  //       onClick={() => setActiveTab("4")}
  //     >
  //       Pending Settlements
  //       <span
  //         style={{
  //           marginLeft: "6px",
  //           background: activeTab === "4" ? "#D85A30" : "#c8ced3",
  //           color: "#fff",
  //           borderRadius: "10px",
  //           padding: "1px 7px",
  //           fontSize: "11px",
  //         }}
  //       >
  //         {pendingData.length} {/* Changed from paidData */}
  //       </span>
  //     </button>
  //   </div>
  // );
  
  const TabBar = () => (
  <div style={{ display: "flex", borderBottom: "2px solid #c8ced3", marginBottom: "12px", marginTop: "52px" }}>
    <button
      style={tabStyle(activeTab === "1", "#1D9E75")}
      onClick={() => setActiveTab("1")}
    >
      Orders Created
      <span
        style={{
          marginLeft: "6px",
          background: activeTab === "1" ? "#1D9E75" : "#c8ced3",
          color: "#fff",
          borderRadius: "10px",
          padding: "1px 7px",
          fontSize: "11px",
        }}
      >
        {createdData.length}
      </span>
    </button>
    <button
      style={tabStyle(activeTab === "2", "#378ADD")}
      onClick={() => setActiveTab("2")}
    >
     Daily Orders Delivered
      <span
        style={{
          marginLeft: "6px",
          background: activeTab === "2" ? "#378ADD" : "#c8ced3",
          color: "#fff",
          borderRadius: "10px",
          padding: "1px 7px",
          fontSize: "11px",
        }}
      >
        {deliveredData.length}
      </span>
    </button>
    <button
      style={tabStyle(activeTab === "3", "#28A745")} // Changed to green for settled
      onClick={() => setActiveTab("3")}
    >
      Orders Settled
      <span
        style={{
          marginLeft: "6px",
          background: activeTab === "3" ? "#28A745" : "#c8ced3",
          color: "#fff",
          borderRadius: "10px",
          padding: "1px 7px",
          fontSize: "11px",
        }}
      >
        {settledData.length}
      </span>
    </button>
    <button
      style={tabStyle(activeTab === "4", "#DC3545")} // Changed to red for pending
      onClick={() => setActiveTab("4")}
    >
      Pending Settlements
      <span
        style={{
          marginLeft: "6px",
          background: activeTab === "4" ? "#DC3545" : "#c8ced3",
          color: "#fff",
          borderRadius: "10px",
          padding: "1px 7px",
          fontSize: "11px",
        }}
      >
        {pendingData.length}
      </span>
    </button>
  </div>
);
  const createdSumLabels = [
    "Bill Amount", "Advance", "Remaining",
  ];
  const deliveredSumLabels = [
    "Bill Amount", "Advance", "Amount Received", "Remaining",
  ];
  const paidSumLabels = [
    "Bill Amount", "Advance", "Amount Received", "Remaining",
  ];

  const paginationOptions = (tableData) => ({
    paginationShowsTotal: true,
    page: 1,
    sizePerPage: 50,
    pageStartIndex: 1,
    paginationSize: 3,
    prePage: "Prev",
    nextPage: "Next",
    firstPage: "First",
    lastPage: "Last",
    paginationPosition: "top",
    sizePerPageList: [
      { text: "10",  value: 10  },
      { text: "30",  value: 30  },
      { text: "50",  value: 50  },
      { text: "100", value: 100 },
      { text: "All", value: tableData?.length || 0 },
    ],
  });

  
  useEffect(() => {
    (async () => {
      await asyncRollCheck();
    })();
  }, []);

  const asyncRollCheck = async () => {
    const empId      = localStorage.getItem("employeeId");
    const rolId      = 2;
    const adminRolId = 1;
    const permFn = await checkPermission(
      empId, adminRolId, rolId, 1, 0, "OverView",
    ); 
  };

  const computeTotals = (rows, fields) => {
    const totals = {};
    fields.forEach((f) => { totals[f] = 0; });
    rows.forEach((r) => {
      fields.forEach((f) => { totals[f] += Number(r[f] || 0); });
    });
    return totals;
  };

  // Only the summed columns are amounts. Keying the number formatting off
  // align === "right" also hit ORDER_NO (right-aligned), and amountFormatter
  // turns a non-numeric document no into "-", so the Excel lost its order nos.
  // The header row prints the labels, not the raw SQL keys.
  const buildExportArr = (rows, keys, totals, labels) => {
    const isAmount = (k) => k.value in totals;

    const headerRow = {};
    keys.forEach((k, i) => { headerRow[k.value] = labels?.[i]?.value || k.value; });

    const dataRows = rows.map((r) => {
      const obj = {};
      keys.forEach((k) => {
        const v = r[k.value];
        obj[k.value] = isAmount(k)
          ? amountFormatter(v)
          : v === null || v === undefined || v === "" ? "-" : v;
      });
      return obj;
    });

    // "Total" goes in the Customer column, as on screen and in the PDF.
    const totalRow = {};
    keys.forEach((k) => {
      totalRow[k.value] = isAmount(k) ? amountFormatter(totals[k.value]) : "";
    });
    totalRow.CUSTOMER = "Total";

    return [{}, headerRow, ...dataRows, {}, totalRow];
  };

  
  const SummaryCard = ({ label, value, color }) => (
    <div
      style={{
        flex: 1,
        background: "#f8f9fa",
        border: "1px solid #e3e6ef",
        borderRadius: "6px",
        padding: "10px 14px",
        minWidth: "120px",
      }}
    >
      <div style={{ fontSize: "11px", color: "#73818f", marginBottom: "4px" }}>
        {label}
      </div>
      <div style={{ fontSize: "16px", fontWeight: "600", color: color || "#2d3748" }}>
        {amountFormatter(value)}
      </div>
    </div>
  );
  
  const renderCreated = () => (
    <>
      <div style={{ display: "flex", gap: "10px", marginBottom: "14px", flexWrap: "wrap" }}>
        <SummaryCard label="Total Orders"  value={createdData.length}          color="#378ADD" />
        <SummaryCard label="Bill Amount"   value={createdTotals.BILL_AMOUNT}   color="#1D9E75" />
        <SummaryCard label="Advance"       value={createdTotals.ADVANCE}       color="#2d3748" />
        <SummaryCard label="Remaining"     value={createdTotals.REMAINING}     color="#D85A30" />
      </div>

      <BootstrapTable
        data={createdData}
        striped
        hover
        pagination
        search
        tableHeaderClass="rpr_header"
        tableBodyClass="rpr_body"
        containerClass="rpr_container"
        options={paginationOptions(createdData)}
        version="4"
      >
        <TableHeaderColumn
          isKey
          dataField="ORDER_NO"
          dataAlign="center"
          width="80"
          dataSort
          className="rpr_header"
        >
          Order No.
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="CUSTOMER"
          dataAlign="left"
          width="130"
          dataSort
          className="rpr_header"
        >
          Customer
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="CUSTOMER_PH"
          dataAlign="center"
          width="130"
          dataSort
          className="rpr_header"
        >
          Customer PH#
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="ORDER_DATE"
          dataAlign="center"
          width="110"
          dataSort
          // dataFormat={dateFormatter}
          className="rpr_header"
        >
          Order Date
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="DELIVERY_PICKUP"
          dataAlign="center"
          width="120"
          dataSort
          dataFormat={typeFormatter}
          className="rpr_header"
        >
          Delivery/Pickup
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="DELIVERY_DATETIME"
          dataAlign="center"
          width="160"
          dataSort
          // dataFormat={dateFormatter}
          className="rpr_header"
        >
          Delivery Date Time
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="BILL_AMOUNT"
          dataAlign="right"
          width="120"
          dataSort
          dataFormat={amountFormatter}
          className="rpr_header"
        >
          Bill Amount
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="ADVANCE"
          dataAlign="right"
          width="110"
          dataSort
          dataFormat={amountFormatter}
          className="rpr_header"
        >
          Advance
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="REMAINING"
          dataAlign="right"
          width="110"
          dataSort
          dataFormat={amountFormatter}
          className="rpr_header"
        >
          Remaining
        </TableHeaderColumn>
      </BootstrapTable>

      {createdData.length > 0 &&
        TableSumCustom(
          createdSumLabels,
          [
            createdTotals.BILL_AMOUNT,
            createdTotals.ADVANCE,
            createdTotals.REMAINING,
          ],
          1,
        )}
    </>
  );

  const renderDelivered = () => (
    <>
      <div style={{ display: "flex", gap: "10px", marginBottom: "14px", flexWrap: "wrap" }}>
        <SummaryCard label="Total Delivered"  value={deliveredData.length}              color="#378ADD" />
        <SummaryCard label="Bill Amount"      value={deliveredTotals.BILL_AMOUNT}       color="#1D9E75" />
        <SummaryCard label="Advance"          value={deliveredTotals.ADVANCE}           color="#2d3748" />
        <SummaryCard label="Amount Received"  value={deliveredTotals.AMOUNT_RECEIVED}   color="#2d3748" />
        <SummaryCard label="Remaining"        value={deliveredTotals.REMAINING}         color="#D85A30" />
      </div>

      <BootstrapTable
        data={deliveredData}
        striped
        hover
        pagination
        search
        tableHeaderClass="rpr_header"
        tableBodyClass="rpr_body"
        containerClass="rpr_container"
        options={paginationOptions(deliveredData)}
        version="4"
      >
        <TableHeaderColumn
          isKey
          dataField="ORDER_NO"
          dataAlign="center"
          width="80"
          dataSort
          className="rpr_header"
        >
          Order No.
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="CUSTOMER"
          dataAlign="left"
          width="130"
          dataSort
          className="rpr_header"
        >
          Customer
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="CUSTOMER_PH"
          dataAlign="center"
          width="130"
          dataSort
          className="rpr_header"
        >
          Customer PH#
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="DELIVERY_DATETIME"
          dataAlign="center"
          width="160"
          dataSort
          // dataFormat={dateFormatter}
          className="rpr_header"
        >
          Delivery Date Time
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="VEHICLENO_PICKUPBY"
          dataAlign="left"
          width="160"
          dataSort
          className="rpr_header"
        >
          Vehicle No./Pickuped by
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="DELIVERED_ON"
          dataAlign="center"
          width="160"
          dataSort
          // dataFormat={dateFormatter}
          className="rpr_header"
        >
          Delivered On
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="BILL_AMOUNT"
          dataAlign="right"
          width="120"
          dataSort
          dataFormat={amountFormatter}
          className="rpr_header"
        >
          Bill Amount
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="ADVANCE"
          dataAlign="right"
          width="110"
          dataSort
          dataFormat={amountFormatter}
          className="rpr_header"
        >
          Advance
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="AMOUNT_RECEIVED"
          dataAlign="right"
          width="130"
          dataSort
          dataFormat={amountFormatter}
          className="rpr_header"
        >
          Amount Received
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="REMAINING"
          dataAlign="right"
          width="110"
          dataSort
          dataFormat={amountFormatter}
          className="rpr_header"
        >
          Remaining
        </TableHeaderColumn>
      </BootstrapTable>

      {deliveredData.length > 0 &&
        TableSumCustom(
          deliveredSumLabels,
          [
            deliveredTotals.BILL_AMOUNT,
            deliveredTotals.ADVANCE,
            deliveredTotals.AMOUNT_RECEIVED,
            deliveredTotals.REMAINING,
          ],
          1,
        )}
    </>
  );

  const renderPending = () => (
    <>
      <div style={{ display: "flex", gap: "10px", marginBottom: "14px", flexWrap: "wrap" }}>
        <SummaryCard label="Total Pending"     value={pendingData.length}              color="#378ADD" />
        <SummaryCard label="Bill Amount"      value={pendingTotals.BILL_AMOUNT}       color="#1D9E75" />
        <SummaryCard label="Advance"          value={pendingTotals.ADVANCE}           color="#2d3748" />
        <SummaryCard label="Amount Received"  value={pendingTotals.AMOUNT_RECEIVED}   color="#2d3748" />
        <SummaryCard label="Remaining"        value={pendingTotals.REMAINING}         color="#D85A30" />
      </div>

      <BootstrapTable
        data={pendingData}
        striped
        hover
        pagination
        search
        tableHeaderClass="rpr_header"
        tableBodyClass="rpr_body"
        containerClass="rpr_container"
        options={paginationOptions(pendingData)}
        version="4"
      >
        <TableHeaderColumn
          isKey
          dataField="ORDER_NO"
          dataAlign="center"
          width="80"
          dataSort
          className="rpr_header"
        >
          Order No.
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="CUSTOMER"
          dataAlign="left"
          width="130"
          dataSort
          className="rpr_header"
        >
          Customer
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="CUSTOMER_PH"
          dataAlign="center"
          width="130"
          dataSort
          className="rpr_header"
        >
          Customer PH#
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="DELIVERY_DATETIME"
          dataAlign="center"
          width="160"
          dataSort
          // dataFormat={dateFormatter}
          className="rpr_header"
        >
          Delivery Date Time
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="DELIVERED_ON"
          dataAlign="center"
          width="160"
          dataSort
          // dataFormat={dateFormatter}
          className="rpr_header"
        >
          Delivered On
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="INSTALLMENTS"
          dataAlign="center"
          width="110"
          dataSort
          className="rpr_header"
        >
          Installments
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="BILL_AMOUNT"
          dataAlign="right"
          width="120"
          dataSort
          dataFormat={amountFormatter}
          className="rpr_header"
        >
          Bill Amount
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="ADVANCE"
          dataAlign="right"
          width="110"
          dataSort
          dataFormat={amountFormatter}
          className="rpr_header"
        >
          Advance
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="AMOUNT_RECEIVED"
          dataAlign="right"
          width="130"
          dataSort
          dataFormat={amountFormatter}
          className="rpr_header"
        >
          Amount Received
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="REMAINING"
          dataAlign="right"
          width="110"
          dataSort
          dataFormat={amountFormatter}
          className="rpr_header"
        >
          Remaining
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="STATUS"
          dataAlign="right"
          width="110"
          dataSort 
          className="rpr_header"
        >
          Status
        </TableHeaderColumn>
      </BootstrapTable>

      {pendingData.length > 0 &&
        TableSumCustom(
          pendingSumLabels,
          [
            pendingTotals.BILL_AMOUNT,
            pendingTotals.ADVANCE,
            pendingTotals.AMOUNT_RECEIVED,
            pendingTotals.REMAINING,
          ],
          1,
        )}
    </>
  );

  // Update renderPaid to renderSettled
  const renderSettled = () => (
    <>
      <div style={{ display: "flex", gap: "10px", marginBottom: "14px", flexWrap: "wrap" }}>
        <SummaryCard label="Total Settled"     value={settledData.length}            color="#378ADD" />
        <SummaryCard label="Bill Amount"      value={settledTotals.BILL_AMOUNT}     color="#1D9E75" />
        <SummaryCard label="Advance"          value={settledTotals.ADVANCE}         color="#2d3748" />
        <SummaryCard label="Amount Received"  value={settledTotals.AMOUNT_RECEIVED} color="#2d3748" />
        <SummaryCard label="Remaining"        value={settledTotals.REMAINING}       color="#D85A30" />
      </div>

      <BootstrapTable
        data={settledData}
        striped
        hover
        pagination
        search
        tableHeaderClass="rpr_header"
        tableBodyClass="rpr_body"
        containerClass="rpr_container"
        options={paginationOptions(settledData)}
        version="4"
      >
        <TableHeaderColumn
          isKey
          dataField="ORDER_NO"
          dataAlign="center"
          width="80"
          dataSort
          className="rpr_header"
        >
          Order No.
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="CUSTOMER"
          dataAlign="left"
          width="130"
          dataSort
          className="rpr_header"
        >
          Customer
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="CUSTOMER_PH"
          dataAlign="center"
          width="130"
          dataSort
          className="rpr_header"
        >
          Customer PH#
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="DELIVERY_DATETIME"
          dataAlign="center"
          width="160"
          dataSort
          // dataFormat={dateFormatter}
          className="rpr_header"
        >
          Delivery Date Time
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="DELIVERED_ON"
          dataAlign="center"
          width="160"
          dataSort
          // dataFormat={dateFormatter}
          className="rpr_header"
        >
          Delivered On
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="INSTALLMENTS"
          dataAlign="center"
          width="110"
          dataSort
          className="rpr_header"
        >
          Installments
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="BILL_AMOUNT"
          dataAlign="right"
          width="120"
          dataSort
          dataFormat={amountFormatter}
          className="rpr_header"
        >
          Bill Amount
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="ADVANCE"
          dataAlign="right"
          width="110"
          dataSort
          dataFormat={amountFormatter}
          className="rpr_header"
        >
          Advance
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="AMOUNT_RECEIVED"
          dataAlign="right"
          width="130"
          dataSort
          dataFormat={amountFormatter}
          className="rpr_header"
        >
          Amount Received
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="REMAINING"
          dataAlign="right"
          width="110"
          dataSort
          dataFormat={amountFormatter}
          className="rpr_header"
        >
          Remaining
        </TableHeaderColumn>
      </BootstrapTable>

      {settledData.length > 0 &&
        TableSumCustom(
          settledSumLabels,
          [
            settledTotals.BILL_AMOUNT,
            settledTotals.ADVANCE,
            settledTotals.AMOUNT_RECEIVED,
            settledTotals.REMAINING,
          ],
          1,
        )}
    </>
  );

  // Update hasData to include pendingData
  const hasData =
    createdData.length > 0 || deliveredData.length > 0 || settledData.length > 0 || pendingData.length > 0;

  return (
    <> 
      <div className="position-relative">
        <div
          className={`container-fluid bg-white ${
            isLoading ? "blur-background" : ""
          }`}
        >
          <ReportsCriteria
            reportName="Day Summary Report"
            lovs={["onlyDate", "branch"]}
            callBack={() => {}}
            isMulti={false}
            companyId={companyId}
            token={token}
            username={username}
            handleFind={(p) => handleFind(p)}
          />
          <div className="row float-right pr-4" style={{ marginBottom: "8px" }}>
            <Button
              color="success"
              className="button-22"
              onClick={handlePrint}
              disabled={!hasData}
            >
              Print
            </Button>

            {hasData && (
              <ExportToExcel
                Data={currentExportData()}
                listOfColKey={currentColKeys()}
                DynamicReports={true}
                ReportName={currentReportName()}
                criteriaString={data.criteriaString}
              />
            )}
          </div>
          <div translate="no" style={{ marginTop: "8px" }}>
            <TabBar />
            {activeTab === "1" && renderCreated()}
            {activeTab === "2" && renderDelivered()}
            {activeTab === "3" && renderSettled()} {/* Changed from renderPaid */}
            {activeTab === "4" && renderPending()} {/* Added pending render */}
            <br />
            <br />
          </div>
        </div>
        {isLoading && (
          <div className="loader-overlay">
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        )}
      </div>
    </>
  );
}